module.exports = __webpack_public_path__ + "img/unpair.bc62b204.png";